import apiConfig from "../../../config/api";
import trace from "../../../helpers/trace";
import store from "../../../config/store";
import { ErrorSnacktOpen } from "../../ErrorSnack/actions";
const download = require("downloadjs");

// //////////////////
// Action Creators //
// //////////////////


export const Loading = (loading) => ({
  type: "FILTROBUSQUEDARCDETALLE/LOADING",
  loading,
});

export const CargarRecargosExcepcionales = (recargosConvenidosExcep) => ({
  type: "FILTROBUSQUEDARCDETALLE/CARGA_RECARGOS_CONVENIDOS_EXCEP",
  recargosConvenidosExcep,
});

export const UpdateDetailTecniques = recargosConvenidosExcep => ({
  type: 'FILTROBUSQUEDARCDETALLE/UPDATE_DETAIL_TECNIQUES',
  recargosConvenidosExcep,
});

// ////////////////////////
// Action Orchestrators  //
// ////////////////////////

export const BuscarRecargosExcepcionales = (filtros) => (dispatch) => {
  const globalState = store.getState().global;
  const params = {
    RutInstitucion: globalState.rutInstitucion,
    RutArancel: filtros.RutArancel,
    CentroAtencion: filtros.CentroAtencion,
    GrupoPrestacion: filtros.GrupoPrestacion,
    TipoProfesional: filtros.TipoProfesional,
    CodigoPrestacion: filtros.CodigoPrestacion,
    Isapre: globalState.isapre,
    token: globalState.token,
  };

  fetch(`${apiConfig.apiUri}/v1/recargoconvenios/searchdetalle/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.json();
    })
    .then((json) => {
      if (Array.isArray(json)) {
        //trace.information("BuscarRecargosExcepcionales", json);
        dispatch(CargarRecargosExcepcionales(json));
      } else {
        throw json;
      }
    })
    .catch((error) => {
      trace.error("BuscarRecargosExcepcionales", error);
      dispatch(ErrorSnacktOpen(
        "Error al obtener recargos convenidos excepcionales:",
        error,
      ));
    });
};


export const DownloadRecargosArancel = (filtros) => (dispatch) => {
  const globalState = store.getState().global;

  const params = {
    RutInstitucion: globalState.rutInstitucion,
    RutArancel: filtros.RutArancel,
    CentroAtencion: filtros.CentroAtencion,
    Isapre: globalState.isapre,
    token: globalState.token,
  };
  fetch(`${apiConfig.apiUri}/v1/recargoconvenios/searchdetalleexcel/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.blob();
    })
    .then((blob) => {
      download(blob, `RecargosArancel_${globalState.rutInstitucion}.xlsx`, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
    })
    .catch((error) => {
      trace.error("DownloadRecargosArancel", error);
      dispatch(ErrorSnacktOpen(
        "Error al descargar los recargos de arancel:",
        error,
      ));
    });
};

export const DownloadRecargosFiltrados = (filtros) => (dispatch) => {
  const globalState = store.getState().global;
  const params = {
    RutInstitucion: globalState.rutInstitucion,
    RutArancel: filtros.RutArancel,
    CentroAtencion: filtros.CentroAtencion,
    GrupoPrestacion: filtros.GrupoPrestacion,
    TipoProfesional: filtros.TipoProfesional,
    CodigoPrestacion: filtros.CodigoPrestacion,
    Isapre: globalState.isapre,
    token: globalState.token,
  };

  fetch(`${apiConfig.apiUri}/v1/recargoconvenios/searchdetalleexcel/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.blob();
    })
    .then((blob) => {
      download(blob, `Recargos_${globalState.rutInstitucion}.xlsx`, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
    })
    .catch((error) => {
      trace.error("DownloadRecargosFiltrados", error);
      dispatch(ErrorSnacktOpen(
        "Error al descargar recargos de arancel filtrados:",
        error,
      ));
    });
};
